export { SessionReplay, SessionReplayPrivacy } from './nativeSessionReplay';
